import FormCreateOrEditCreator from './FormCreateOrEditCreator';
import { ICreator, IHasErrorMessage } from '@/interfaces';
import { TCallbackForm } from '@/types';

export default FormCreateOrEditCreator;

export type TProps = {
  callback?: TCallbackForm<ICreator>;
  requireReferralCode?: boolean;
  textBtnCancel?: string;
  creator?: ICreator;
  readonly?: boolean;
  fieldNames?: {
    links?: string;
  }
};

export type TFormData = Omit<
  ICreator,
  | 'updatedAt'
  | 'createdAt'
> & IHasErrorMessage;
